import { Route, Routes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import { LoadingSpinner, NavigationLayout, PageLayout } from "./components/ui";
import {
  PositionsDataContext,
  PositionsDataProvider,
} from "./context/PositionsDataContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { NavProvider } from "./context/NavContext";

// Page components
import ProtectedRoute from "./components/ProtectedRoute";
import { useContext } from "react";
import { routesConfig } from "./routesConfig";
import Healthcheck from "./components/pages/Healthcheck";
import OpsAlertNotifier from "./components/OpsAlertNotifier";

const AppContent = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isLoading: positionsLoading } = useContext(PositionsDataContext);

  // Check if we're in popup mode
  const isPopup =
    new URLSearchParams(window.location.search).get("popup") === "true";

  if (!isAuthenticated || authLoading) {
    return null; // Wait for authentication
  }

  if (positionsLoading) {
    return <LoadingSpinner message="Loading application data..." />;
  }

  // If in popup mode, render without NavigationLayout
  if (isPopup) {
    return (
      <ProtectedRoute>
        <Routes>
          {routesConfig.map(({ path, element }, idx) => (
            <Route key={idx} path={path} element={element} />
          ))}
        </Routes>
      </ProtectedRoute>
    );
  }

  return (
    <NavigationLayout title="Glazer App">
      <OpsAlertNotifier />
      <PageLayout>
        <ProtectedRoute>
          <Routes>
            {routesConfig.map(({ path, element }, idx) => (
              <Route key={idx} path={path} element={element} />
            ))}
          </Routes>
        </ProtectedRoute>
      </PageLayout>
    </NavigationLayout>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/health" element={<Healthcheck />} />
        <Route
          path="*"
          element={
            <AuthProvider>
              <NavProvider>
                <PositionsDataProvider>
                  <AppContent />
                </PositionsDataProvider>
              </NavProvider>
            </AuthProvider>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
